export enum DoorOverlayEnum {
  FULL = 'Full',
  INSET = 'Inset',
  STANDARD = 'Standard',
}
